export { LiberacionEntregaZEList } from "./list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/list/index.tsx